import { useQuery } from '@apollo/client'
import dayjs from 'dayjs'

import { extractByTypename } from '@local/utils'

import { useErrorToast } from '@web/hooks/useErrorToast'
import { useGoTo } from '@web/hooks/useGoTo'
import routes from '@web/libs/constants/routes'
import { getMissionTitle } from '@web/pages/v5/home/MissionSection/helper'
import { MissionSectionQuery } from '@web/pages/v5/home/MissionSection/query'
import UIMissionSection from '@web/ui/pages/home/components/Sections/UIMissionSection'
import MissionCardItem from '@web/ui/pages/home/components/Sections/UIMissionSection/components/MissionCardItem'

const DISPLAY_MISSION_CARD_COUNT = 5
type Props = {}

const MissionSection = ({}: Props) => {
  const { data, error } = useQuery(MissionSectionQuery)
  useErrorToast(error)
  const { goTo } = useGoTo()

  const { CurrentMissionSummariesSucceed } = extractByTypename(data?.currentMissionSummaries)

  if (!CurrentMissionSummariesSucceed) return null

  const cards = CurrentMissionSummariesSucceed.missionSummaries.map<React.ComponentProps<typeof MissionCardItem>>(
    mission => ({
      key: mission.id,
      name: mission.name,
      isBeforeStart: mission.stampCount === 0,
      progressCount: mission.stampCount,
      totalCount: mission.stampCountToComplete,
      stampName: mission.stampName,
      imageUrl: mission.imageUrl,
      borderImageUrl: mission.borderImageUrl,
      isInfiniteMission: !mission.stampCountToComplete,
      url: mission.detailUrl,
      isParticipating: CurrentMissionSummariesSucceed.isParticipating,
    }),
  )

  const handleClickMore = () => {
    goTo(routes.MISSION)
  }

  const { title, description } = getMissionTitle({
    isParticipating: CurrentMissionSummariesSucceed.isParticipating,
    month: dayjs(CurrentMissionSummariesSucceed.startDateTime).get('month') + 1,
    dday: CurrentMissionSummariesSucceed.dday,
  })

  return (
    <UIMissionSection
      cards={cards.slice(0, DISPLAY_MISSION_CARD_COUNT)}
      title={title}
      description={description}
      onClickMore={handleClickMore}
      displayMoreButton={cards.length > 2}
      isParticipating={CurrentMissionSummariesSucceed.isParticipating}
    />
  )
}

export default MissionSection
